import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { permCan } from "@/lib/constants";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export default function VisToggle({ kind, id, photoId = "", visible, small, onChanged, testid }) {
  const { permissions } = useAuth();
  const [on, setOn] = useState(!!visible);
  if (!permCan(permissions, "portail", "write")) return null;
  const flip = async (e) => {
    e.stopPropagation();
    try { await api.post("/portal-admin/visibility", { kind, id, photo_id: photoId, visible: !on }); setOn(!on); toast.success(!on ? "Publié sur le portail client" : "Retiré du portail client"); onChanged && onChanged(); }
    catch (err) { toast.error(apiErr(err)); }
  };
  const I = on ? Eye : EyeOff;
  if (small) return (
    <button type="button" onClick={flip} title={on ? "Visible par le client" : "Interne (non visible)"} data-testid={testid}
      className={`absolute bottom-0.5 left-0.5 rounded-full p-0.5 ${on ? "bg-emerald-500 text-white" : "bg-white/90 text-slate-500"}`}><I className="h-3 w-3" /></button>
  );
  return (
    <label className={`inline-flex items-center gap-1.5 text-xs rounded-full px-2.5 py-1 cursor-pointer select-none ${on ? "bg-emerald-100 text-emerald-800" : "bg-slate-100 text-slate-500"}`} data-testid={testid}>
      <input type="checkbox" checked={on} onChange={flip} className="accent-emerald-600" />Visible client
    </label>
  );
}
